/* SEP 27 2026: wrapped so it can be included by both the vac-stock-priority section and the pagination snippet
   without double-running. "View 50 | 100" and page numbers now work on every collection page, including the State
   Guard family (which only skips the forced in-stock filter). "View 50" on collections whose own template is the
   100-per-page template switches to the 50-per-page twin (?view=50). */
(function () {
  if (window.__vacStockPriorityV2) return;
  window.__vacStockPriorityV2 = true;

  const VAC_AVAILABILITY_PARAM = 'filter.v.availability';
  const VAC_IN_STOCK = '1';
  const KEEP_VIEWS = ['50', '100', 'packs-carry-100'];

  function isStateGuardFamily() {
    const path = window.location.pathname.toLowerCase();
    return path.includes('/collections/state-guard') || path.includes('naval-militia');
  }
  function isAnyCollectionPage() {
    return window.location.pathname.startsWith('/collections/');
  }
  function forcesInStock() {
    return isAnyCollectionPage() && !isStateGuardFamily();
  }

  function normalizeInitialCollectionUrl() {
    if (!forcesInStock() || window.Shopify?.designMode) return false;
    const url = new URL(window.location.href);
    const availability = url.searchParams.get(VAC_AVAILABILITY_PARAM);
    if (availability !== VAC_IN_STOCK && availability !== '0') {
      url.searchParams.set(VAC_AVAILABILITY_PARAM, VAC_IN_STOCK);
      url.searchParams.delete('page');
      window.location.replace(url.toString());
      return true;
    }
    return false;
  }

  function patchFacetForm() {
    if (!isAnyCollectionPage()) return;
    customElements.whenDefined('facets-form-component').then(() => {
      const FacetsForm = customElements.get('facets-form-component');
      if (!FacetsForm || FacetsForm.prototype.__vacStockPriorityPatched) return;
      const original = FacetsForm.prototype.createURLParameters;
      if (typeof original !== 'function') return;
      FacetsForm.prototype.createURLParameters = function patchedCreateURLParameters(formData) {
        const parameters = original.call(this, formData);
        if (this.dataset.pageType === 'collection') {
          if (!isStateGuardFamily()) parameters.set(VAC_AVAILABILITY_PARAM, VAC_IN_STOCK);
          parameters.delete('page');
          const currentView = new URL(window.location.href).searchParams.get('view');
          if (KEEP_VIEWS.includes(currentView)) parameters.set('view', currentView);
        }
        return parameters;
      };
      FacetsForm.prototype.__vacStockPriorityPatched = true;
    });
  }

  function hideAvailabilityControls(root = document) {
    if (!forcesInStock()) return;
    root.querySelectorAll(`input[name="${VAC_AVAILABILITY_PARAM}"]`).forEach((input) => {
      const details = input.closest('details');
      const item = input.closest('.facets__item');
      if (details instanceof HTMLElement) details.hidden = true;
      else if (item instanceof HTMLElement) item.hidden = true;
    });
  }

  function goToGlobalPage(link) {
    const nav = link.closest('[data-vac-in-stock-pages]');
    const target = Math.max(1, Number(link.dataset.vacGlobalPage || 1));
    const url = new URL(window.location.href);
    let page = target;
    if (forcesInStock() && nav instanceof HTMLElement) {
      const inStockPages = Number(nav.dataset.vacInStockPages || 0);
      if (inStockPages > 0) page = Math.min(target, inStockPages);
      url.searchParams.set(VAC_AVAILABILITY_PARAM, VAC_IN_STOCK);
    }
    url.searchParams.set('page', String(page));
    url.hash = '';
    window.location.assign(url.toString());
  }

  function setPageSize(link) {
    const size = link.dataset.vacPageSize;
    if (size !== '50' && size !== '100') return;
    const url = new URL(window.location.href);
    const pageView = link.dataset.vacPageView || '';
    if (pageView) url.searchParams.set('view', pageView);
    else url.searchParams.delete('view');
    if (forcesInStock()) url.searchParams.set(VAC_AVAILABILITY_PARAM, VAC_IN_STOCK);
    url.searchParams.delete('page');
    url.hash = '';
    window.location.assign(url.toString());
  }

  function bindPagination() {
    document.querySelectorAll('[data-vac-global-page]').forEach((link) => {
      if (link.dataset.vacBound === 'true') return;
      link.dataset.vacBound = 'true';
      link.addEventListener('click', (event) => { event.preventDefault(); goToGlobalPage(link); });
    });
    document.querySelectorAll('[data-vac-page-size]').forEach((link) => {
      if (link.dataset.vacBound === 'true') return;
      link.dataset.vacBound = 'true';
      link.addEventListener('click', (event) => { event.preventDefault(); setPageSize(link); });
    });
  }

  function initialize() {
    if (!isAnyCollectionPage()) return;
    hideAvailabilityControls();
    bindPagination();
  }

  if (!normalizeInitialCollectionUrl()) {
    patchFacetForm();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; initialize(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
